import { Component, type ErrorInfo, type PropsWithChildren } from 'react';
import Toast from 'react-bootstrap/Toast';

import { logger } from '@/components/SgwtBootstrap/logger.ts';

type Props = PropsWithChildren<{
  growlId: string;
  growlType: string;
  productName: string;
}>;

type State = {
  hasError: boolean;
};

export class GrowlCatchAll extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.logError(
      'Growl error boundary caught for growl {growlId_s}: {error_s} {errorInfo_s}',
      this.props.growlId,
      JSON.stringify(error),
      JSON.stringify(errorInfo),
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Toast.Header className="bg-danger text-white">
            <strong className="me-auto">Notification error</strong>
          </Toast.Header>
          <Toast.Body className="d-flex flex-column gap-8px text-danger fs-12">
            <div>
              An error occurred while displaying this <strong>{this.props.productName}</strong> notification.
            </div>
            <div className="text-secondary">
              {this.props.growlType} — {this.props.growlId}
            </div>
          </Toast.Body>
        </>
      );
    }
    return this.props.children;
  }
}
